import { render, staticRenderFns } from "./RadioToggleButtons.vue?vue&type=template&id=4ed4ef3a&scoped=true&"
import script from "./RadioToggleButtons.vue?vue&type=script&lang=ts&"
export * from "./RadioToggleButtons.vue?vue&type=script&lang=ts&"
import style0 from "./RadioToggleButtons.vue?vue&type=style&index=0&id=4ed4ef3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4ef3a",
  null
  
)

export default component.exports